import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SwiperDirective } from '../directive/swiper/swiper.directive';
import { PicFolderComponent } from '../pic-folder/pic-folder.component';
import { IonicModule } from '@ionic/angular/lazy';
import { ZoomPanDirective } from '../directive/zoom-pan/zoom-pan.directive';
import { LiveCodeScannerComponent } from '../job-detail/live-code-scanner/live-code-scanner.component';
import { FormsModule } from '@angular/forms';
import { ContinuousCameraComponent } from './continuous-camera/continuous-camera.component';
import { SelectableInputComponent } from './selectable-input/selectable-input.component';
import { ImageAnnotationEditorComponent } from './image-annotation-editor/image-annotation-editor.component';
import { FloatingButtonsComponent } from './floating-buttons/floating-buttons.component';
import { VditorEditorComponent } from './vditor-editor/vditor-editor.component';



@NgModule({
  declarations: [ZoomPanDirective, SwiperDirective, PicFolderComponent, LiveCodeScannerComponent, ContinuousCameraComponent, SelectableInputComponent, ImageAnnotationEditorComponent, FloatingButtonsComponent, VditorEditorComponent],
  exports: [ZoomPanDirective, SwiperDirective, PicFolderComponent, LiveCodeScannerComponent, ContinuousCameraComponent, SelectableInputComponent, ImageAnnotationEditorComponent, FloatingButtonsComponent, VditorEditorComponent],
  imports: [
    IonicModule,
    CommonModule,
    FormsModule
  ]
})
export class SharedModule { }
